<!-- @format -->
<!-- if not isAttributeErrorUpdatedEnabled, this gets hidden in favor of the error alert -->
<!-- if / when isAttributeErrorUpdatedEnabled is enabled everywhere, turn this into a simple if/else -->
@if (isAttributeErrorUpdatedEnabled() || !(errorMessage() && errorMessageDisplayable())) {
	<span class="hmf-header-bold-xs hmf-text-transform-none">{{ attributeGroupName() }}: </span>
	@if (selectedAttributeValueDisplayable()) {
		<span class="hmf-header-xs hmf-text-transform-none">{{ selectedAttributeValue() }}</span>
	}
}
@if (errorMessage() && errorMessageDisplayable()) {
	@if (isAttributeErrorUpdatedEnabled()) {
		<hmf-alert-banner
			messageType="error"
			[messageTitle]="errorMessage()"
			class="hmf-mt-xs hmf-display-block"></hmf-alert-banner>
	} @else {
		<span class="hmf-body-bold-m hmf-display-flex hmf-align-items-start label-negative">
			<homefield-icon
				width="20px"
				height="20px"
				fill="currentColor"
				name="alert-info-filled"
				class="hmf-display-flex"></homefield-icon>
			<span class="hmf-ml-xxs">{{ errorMessage() }}</span>
		</span>
	}
}
